import styled from "styled-components";
import { NEAR_WHITE } from "../../config";

export const LoadingAndEmptyText = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 22px;
  color: ${NEAR_WHITE};
`;
